jQuery(document).ready(function () {

  
$('a.scrollto').each(function(){
  $(this).on('click',function(event){
    event.preventDefault();
    var thisTarget = $(this).attr('data-target');
    $('html, body').animate({
        scrollTop: $( '#'+thisTarget ).offset().top - 90
    }, 300);
  });
});
  

// ----------- Mobile menu -------
jQuery(function($) {
    $('#main-menu nav').meanmenu();

    $('.mean-nav .mean-expand').on('click',function(){
      $(this).closest('li').siblings('li').find('.mean-expand').text('+').removeClass('mean-clicked');
      $(this).closest('li').siblings('li').find('> ul,> .dropdown > .dropdown-padding > ul').slideUp();
    });
});


// ----------- Main Slider ----------------
/*jQuery('.hero-slider .bxslider li').each(function(index, element) {
    var slide_img = jQuery('.slide_img img',this).attr("src");
	jQuery(this).css('background','url(' + slide_img + ') center center');
});

function resizeContent() {
    var height_screen = jQuery(window).height();
    jQuery('.hero-slider ul li').height(height_screen);

	// ----------------- Center for Caption ----------------
	jQuery('.hero-slider .bxslider li .caption').each(function(index, element) {
        var width = jQuery(this).width()/2;
      	var header_hi = jQuery('header').height();
		//console.log(header_hi);
		var height = ((jQuery(this).height()) - header_hi)/2 ;
		//console.log(height);
		jQuery(this).css('margin-left',-width);
		jQuery(this).css('margin-top',-height);
    });

}

resizeContent();

jQuery(window).resize(function() {
	resizeContent();
});
*/
  
if ( jQuery( ".bxslider" )!==null && jQuery( ".bxslider" ).length!== 0 ) {
  if ($('.bxslider').hasClass('arrowed')) {
    $('.bxslider').bxSlider({
      mode: 'fade',
      captions: true,
      controls: true,
      pager: false,
      auto: true
    });
  } else {
    $('.bxslider').bxSlider({
      mode: 'fade',
      captions: true,
      controls: false,
      auto: true
    });
  }
}

// ------------- Carousel --------------------

if(jQuery(window).width() < 480 ){
  jQuery('#carousel').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:1,
    maxSlides:1,
    slideWidth:195
  });
}
else if(jQuery(window).width() > 480 && jQuery(window).width() < 767){
  jQuery('#carousel').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:2,
    maxSlides:2,
    slideWidth:195,
    moveSlides:1
  });
}
else
{
  jQuery('#carousel').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:6,
    maxSlides:6,
    moveSlides: 1,
    slideWidth:195
  });
}


if(jQuery(window).width() < 480 ){
  jQuery('#carousel2').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:1,
    maxSlides:1,
    slideWidth:195
  });
}
else if(jQuery(window).width() > 480 && jQuery(window).width() < 767){
  jQuery('#carousel2').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:2,
    maxSlides:2,
    slideWidth:195,
    moveSlides:1
  });
}
else
{
  jQuery('#carousel2').bxSlider({
    captions: true,
    controls: true,
    pager:false,
    minSlides:6,
    maxSlides:6,
    moveSlides: 1,
    slideWidth:195
  });
}




// *************************** Carousel *******************************

if(jQuery(window).width() < 480 ){
	jQuery('.might_like_art').bxSlider({
		captions: true,
		controls: true,
		pager:false,
		minSlides:1,
		maxSlides:1,
		slideWidth:300,
		slideMargin:30
	});
}
else if(jQuery(window).width() > 480 && jQuery(window).width() < 767){
	jQuery('.might_like_art').bxSlider({
		captions: true,
		controls: true,
		pager:false,
		minSlides:2,
		maxSlides:2,
		slideWidth:220,
		slideMargin:30
	});
}
else if(jQuery(window).width() < 1000 && jQuery(window).width() > 768){
	jQuery('.might_like_art').bxSlider({
		captions: true,
		controls: true,
		pager:false,
		minSlides:4,
		maxSlides:4,
        moveSlides: 1,
		slideWidth:260,
		slideMargin:10
	});
}
else{
jQuery('.might_like_art').bxSlider({
	captions: true,
	controls: true,
	pager:false,
	minSlides:5,
	maxSlides:5,
    moveSlides: 1,
	slideWidth:210,
	slideMargin:30
});
}

// ----------------- Slider for collection ---------------------

/*if(jQuery(window).width() < 480 ){
	jQuery('.collection-section .listing').bxSlider({
		captions: true,
		controls: true,
		pager:false,
		minSlides:1,
		maxSlides:1,
        moveSlides: 1,
		slideWidth:300,
		slideMargin:30
	});
}
else if(jQuery(window).width() < 767 && jQuery(window).width() > 480){
	jQuery('.collection-section .listing').bxSlider({
		captions: true,
		controls: true,
		pager:false,
		minSlides:2,
		maxSlides:2,
        moveSlides: 1,
		slideWidth:200,
		slideMargin:20
	});
}*/


// -------------- Artwork Slider ------------------

if(jQuery(window).width() < 480 ){
	jQuery('.artwork-section').bxSlider({
	  mode: 'fade',
	  captions: true,
	  pager:false,
	  minSlides:1,
	  maxSlides:1,
	  slideWidth:310,
	  slideMargin: 10
    });
}
else if(jQuery(window).width() < 767 && jQuery(window).width() > 480 ){
	jQuery('.artwork-section').bxSlider({
	mode: 'fade',
	captions: true,
	pager:false,
  	minSlides:1,
	maxSlides:1,
	slideWidth:350,
	slideMargin: 10

	});
}


// -------------- Client Slider ------------------

if(jQuery(window).width() < 480 ){
	jQuery('.client-slide').bxSlider({
	  mode: 'fade',
	  captions: true,
	  pager:false
	});
}


// -------------- Instagram Slider ------------------

if(jQuery(window).width() < 480 ){
	jQuery('.insta-slide').bxSlider({
	  mode: 'fade',
	  captions: true,
	  pager:false
	});
}


// ---------------- Animated Header -----------------


var fixed_menu = true;
window.jQuery = window.$ = jQuery;

var demo = true;

jQuery(document).ready(function() {

 //Fixed Menu
 if (jQuery('.fixed-menu').size() && fixed_menu == true) {

  var fixd_menu = setInterval(scrolled_menu, 100);

 }

});

var fixed_menu = true;
window.jQuery = window.$ = jQuery;
var demo = true;


 //Fixed Menu
 if (jQuery('.fixed-menu').size() && fixed_menu == true) {

  var fixd_menu = setInterval(scrolled_menu, 100);

 }


function scrolled_menu() {
 if (jQuery(window).scrollTop() > jQuery('header-new').height()+145) {
  jQuery('.fixed-menu').addClass('fixed_show');
  jQuery('.page-container .header-new:first').hide();

 } else {
  jQuery('.fixed-menu').removeClass('fixed_show');
  jQuery('.page-container .header-new:first').show();
 }
}


// ---------------- Scroll To Top -------------------

//Check to see if the window is top if not then display button
jQuery(window).scroll(function(){
	if (jQuery(this).scrollTop() > 100) {
		jQuery('.scrollToTop').fadeIn();
	} else {
		jQuery('.scrollToTop').fadeOut();
	}
});

//Click event to scroll to top
jQuery('.scrollToTop').click(function(){
	jQuery('html, body').animate({scrollTop : 0},800);
	return false;
});

// ------------------ Accordion ------------------

jQuery( "#accordion" ).accordion({
	collapsible: true,
	heightStyle: "content"
});



});// Document ready end


/*==================  view chart  =======================*/

jQuery(".chart").colorbox({rel:'group3', transition:"none", width:"75%", height:"75%"});


jQuery(function() {
	jQuery( "#tabs" ).tabs();
	jQuery( "#product_info").tabs();
	jQuery( "#recommended" ).tabs({
      active: 1
    });
});



jQuery(window).load(function () {

	//for cartpage
	/*var get_Pro_url = $.cookie('Pro_url');
	if(get_Pro_url != 'null'){
		$.cookie('Pro_url',null , { expires: 7, path: '/' });
	}*/
    if ( jQuery( ".edit" )!==null && jQuery( ".edit" ).length!== 0 ) {
      jQuery('.edit').click(function(e) {
          e.preventDefault()

          var get_url = jQuery(this).attr('href');
          //var get_variant = jQuery(this).data('varaint');
          //var get_qty = jQuery(this).data('qty');

          $.cookie('Pro_url', get_url , { expires: 7, path: '/' });
          //$.cookie('Pro_variant', get_variant , { expires: 7, path: '/' });
          //$.cookie('Pro_qty', get_qty , { expires: 7, path: '/' });

          //redirect();

          jQuery(this).parents('.cart-item').find('#quantity').val('0');
          jQuery('#update-cart').trigger('click');
      });
    }

	/*function redirect(){
		var get_Pro_url = $.cookie('Pro_url');
	    if(get_Pro_url != 'null'){
			window.location.href = get_Pro_url;
	    }
	}*/

	// For last-child in variant
  if ( jQuery( "#add-item-form" )!==null && jQuery( "#add-item-form" ).length!== 0 ) {
	jQuery('#add-item-form .main-variant .varinat-loop').each(function(index, element) {
        jQuery('.right_part > div:last',this).addClass('last-div');
    });
  }

    if(jQuery(window).width() > 767 ){
      var $container = jQuery('.artwork_list');
      $container.imagesLoaded(function () {
          $container.isotope({
             itemSelector: '.art_item',
             layoutMode: 'fitRows'
          });
      });
      jQuery('.filter_nav li a').click(function () {
          jQuery('.filter_nav li a').removeClass('active');
          jQuery(this).addClass('active');
          var selector = jQuery(this).attr('data-filter');
          $container.isotope({
              filter: selector
          });
          return false;
      });
    }
  
  

  $.each(jQuery('[data-dynamic="heightify"]'), function(i,v){
    var heightifyElem = jQuery(v);

    var heightifyThis = function() {

        var totalImages = heightifyElem.find('.grid__cell img').length;
        var imagesLoaded = 0;

        var maxHeight = -1;
        var maxHeightPadless = -1;

      heightifyElem.children('.grid__cell:first,ul:first,.hc').each(function() {

            maxHeight = maxHeight > jQuery(this).outerHeight(true) ? maxHeight : jQuery(this).outerHeight(true);

            //after all images are loaded, just in case.
            heightifyElem.find('.grid__cell img').each(function() {
                var fakeSrc = heightifyElem.attr('src');
                jQuery('<img/>').attr('src', fakeSrc).css('display', 'none').load(function() {
                    imagesLoaded++;
                    if (imagesLoaded >= totalImages) {
                        maxHeight = maxHeight > heightifyElem.outerHeight(true) ? maxHeight : heightifyElem.outerHeight(true);
                    }
                });
            });
        });
      

      heightifyElem.children('.grid__cell:first,.hc:first').height(maxHeight);

        var heightifyElemContent = heightifyElem.children('.grid__cell').find('.heightify-content');

        if (heightifyElemContent.length > 0) {

            heightifyElemContent.each(function() {
                maxHeightPadless = maxHeightPadless > jQuery(this).height() ? maxHeightPadless : jQuery(this).height();
            });

            heightifyElemContent.height(maxHeightPadless);

            //after all images are loaded, just in case.
            heightifyElem.find('img').each(function() {
                var fakeSrc = jQuery(this).attr('src');
                jQuery('<img/>').attr('src', fakeSrc).css('display', 'none').load(function() {
                    imagesLoaded++;
                    if (imagesLoaded >= totalImages) {
                        heightifyElemContent.each(function() {
                            maxHeightPadless = maxHeightPadless > jQuery(this).height() ? maxHeightPadless : jQuery(this).height();
                        });

                        heightifyElemContent.height(maxHeightPadless);
                    }
                });

            });

        }

    };
    
    heightifyThis();
    
    var resizeTimer;

    jQuery(window).on('resize', function(e) {

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
    
        heightifyElem.children('.grid__cell').height('auto');
        if (heightifyElem.find('.heightify-content').length > 0) {
            heightifyElem.children('.grid__cell').find('.heightify-content').height('auto');
        }
        heightifyThis();

      }, 750);
    
    });
    
  }); 
});




//add_another
var index_number = 2;
jQuery('.add_another').click(function(e) {
    jQuery('.All_gift_card').append('<div class="item_loop_item"><div class="row-2 first_selectbox"><label>how many gift cards?</label><input type="text" placeholder="1" name="contact[how many gift cards '+ index_number +']"/></div><div class="row-2"><label>What is the gift value on the cards?</label><input type="text" placeholder="ex: $25" name="contact[gift value '+ index_number +']"/></div><div class="clear"></div></div>');
	index_number++;
});



jQuery('.accordion_pager ul li a.next').click(function(e) {
    jQuery(this).parents('li.item').next().find('h3').trigger('click');
});
jQuery('.accordion_pager ul li a.prv').click(function(e) {
    jQuery(this).parents('li.item').prev().find('h3').trigger('click');
});

// Hide "releted_boston" div is there is no local artwork.
var local_art_num = jQuery('.releted_boston .might_like_art > div').length;
if(local_art_num == 0){
	jQuery('.releted_boston').hide();
}
